import { useState } from 'react'

export default function useDocumentItemState() {
    const [modal, setModal] = useState(false);

    return {
        modal,
        updateModal: setModal
    }
}